import {createStrokeSVG} from './TEMPLATE'

// tabler: clipboard
export const Clipboard_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2',
    'M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
